export const normalizeToNumber = (
  val: string | number
) => {
  if (typeof val !== "number") val = parseFloat(val);
  if (!Number.isFinite(val)) val = 0;
  return val;
}